import { ActivatedRoute } from '@angular/router';
import { NEW_HOMES_CATEGORIES, CategoryEnum } from '@classifieds-sell/datalayer';

export const isEditPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return routerData(route, isParent).editing === true;
};

export const isRelistPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return routerData(route, isParent).relisting === true;
};

export const isEditOrRelistPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return isEditPage(route, isParent) || isRelistPage(route, isParent);
};

export const isCreatePage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return !isEditOrRelistPage(route, isParent);
};


export const isAgentPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return routerData(route, isParent).agent === true;
};

export const isNewHomeCategory = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return (
        NEW_HOMES_CATEGORIES.indexOf(routerData(route, isParent).categoryId) !==
        -1
    );
};
export const routerParas = (route: ActivatedRoute, isParent = false): any => {
  let paras = {};

  while (route) {
    const { snapshot } = route;

    paras = {
      ...paras,
      ...snapshot.params
    };
    route = isParent ? route.firstChild : route.parent;
  }

  return paras;
};

export const isLifeStyleCategory = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return (
        routerData(route, isParent).categoryId === CategoryEnum.lifeStyle
    );
};

const routerData = (route: ActivatedRoute, isParent = false): any => {
    let data = {};

    while (route) {
        const { snapshot } = route;

        data = {
            ...data,
            ...snapshot.data
        };
        route = isParent ? route.firstChild : route.parent;
    }

    return data;
};
